import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useCompanyLogo() {
  const { company, logoVersion, user } = useAuth();
  const [url, setUrl] = useState(null);
  const hasLogo = !!company?.has_logo && user?.role === "owner";

  useEffect(() => {
    let href = null;
    let alive = true;
    if (!hasLogo) {
      setUrl(null);
      return undefined;
    }
    api.get("/settings/logo", { responseType: "blob" })
      .then((r) => {
        if (!alive) return;
        href = URL.createObjectURL(r.data);
        setUrl(href);
      })
      .catch(() => alive && setUrl(null));
    return () => {
      alive = false;
      if (href) URL.revokeObjectURL(href);
    };
  }, [hasLogo, logoVersion]);

  return url;
}
